import { Icon } from '@tcc/crate';

// Components
import { getMessage } from '@tcc/i18n';
import Card from '../../../components/cards/cardAndPreview/Card';
import FieldThumbnail from '../../../components/FieldThumbnail/FieldThumbnail';

// Selectors
import { getFieldNotesActivities } from '../../../selectors/scoutingSelectors';
import { getInversedFieldBoundary } from '../../../selectors/fieldSelectors';

// Utils and Constants
import { toDateString } from '../../../utils/date';
import { getGeoJson } from '../../../utils/geo';
import { ModalMode, ModalType } from '../../../types';

// Actions
import { openModal } from '../../../actions/modalActions';

import styles from './FieldNotesCard.css';

import { useAppDispatch, useAppSelector } from '../../../utils';
import { getLocale } from '../../../selectors';


export const FieldNotesCard = ({ index }) => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(state => state);

  const activities = getFieldNotesActivities(state, { index });
  const fieldBoundary = getInversedFieldBoundary(state);
  const locale = getLocale(state)

  const addNote = () => {
    dispatch(openModal(index, null as never, {
      type: ModalType.SCOUTING_FORM,
      mode: ModalMode.ADD_NOTE,
    }));
  };

  const showNote = (activity) => {
    dispatch(openModal(index, null as never, {
      type: ModalType.SCOUTING_FORM,
      edit: true,
      mode: ModalMode.SHOW_NOTE,
      activity,
    }));
  };

  return (
    <Card
      cardType="field-notes"
      icon={Icon.set.ADD_CIRCLE}
      iconClassName={styles.icon}
      onClickIcon={addNote}
      testId="dmb-field-notes-card"
      title={getMessage('card.fieldNotes')}
    >
      {activities.length === 0 ? (
        <div className={styles.empty} data-test-id="no-field-notes">
          {getMessage('card.noFieldNotes')}
        </div>
      ) : (
        activities.map((activity) => {
          const { id, title, scoutedAt, color } = activity;
          return (
            <div
              className={styles.row}
              data-test-id="field-notes"
              key={id}
              onClick={() => showNote(activity)}
              role="button"
              tabIndex={0}
            >
              <div
                className={styles.thumbnailWrapper}
                data-test-id="field-thumbnail"
              >
                <FieldThumbnail
                  fillColor="#EBF2FF"
                  geoJson={getGeoJson([fieldBoundary])}
                  pinColor={color}
                />
              </div>
              <div className={styles.fieldNotes}>
                <div className={styles.title} data-test-id="field-note-title">
                  {title || '-'}
                </div>
                <time
                  className={styles.subtitle}
                  data-test-id="field-note-scoutedAt"
                >
                  {toDateString(scoutedAt, locale)}
                </time>
              </div>
            </div>
          );
        })
      )}
    </Card>
  );
}
